<template>
  <form>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="members">Search Members</label>
              <div
                class="input-wrapper d-flex mb-2"
                v-for="(addedMember, index) in addedMembers"
                :key="index"
              >
                <input
                  type="text"
                  :value="addedMember.label"
                  class="form-control"
                  disabled
                />
                <ActionButton
                  label="x"
                  type="button"
                  :theme="{ primary, secondary, event, danger }"
                  class="w-auto py-0 mt-0"
                  @customEvent="handleMemberRemoveClick({ index })"
                />
              </div>
              <div class="input-wrapper d-flex">
                <CustomSelect
                  :options="users"
                  :searchable="true"
                  :noOptions="'No results found'"
                  :placeholder="'Choose a member'"
                  v-model="selectedMember"
                  @handleOptions="fetchUsers"
                  @typing="handleType"
                  :isLoading="isLoading"
                  form_type="form_type"
                />
                <ActionButton
                  label="+"
                  type="button"
                  :theme="{ primary, secondary, event, danger }"
                  class="w-auto py-0 mt-0"
                  @customEvent="handleAddMemberClick"
                />
              </div>
              <div class="input-wrapper d-flex"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group text-right mb-0">
              <ActionButton
                label="Add"
                :theme="{ primary, secondary, event, danger }"
                @customEvent="handleAddMemberToCompany"
                style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/axios";
import CustomSelect from "@/components/Select";
import searchInput from "../../../admin/components/manage-members/_parseSearch";

export default {
  name: "AddCompanyMembers",
  components: {
    ActionButton,
    CustomSelect
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$store.dispatch("USER_LIST_RESET");
    this.fetchUsers({ search: "" });
  },
  mounted() {},
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    users() {
      let { Users } = this.singleRecord;
      var items = this.$store.state.admin.users.filter(user => {
        Object.assign(user, {
          label: user.firstName + " " + user.lastName,
          value: user.id
        });
        if (
          Users.find(i => user.id === i.id) ||
          this.addedMembers.find(i => user.id === i.id)
        ) {
          // return false if added
          return false;
        }
        return true;
      });
      return items;
    }
  },
  data() {
    return {
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      errorPallete: {
        main: "#dc3545",
        event: "#c82333"
      },
      addedMembers: [],
      selectedMember: null,
      isLoading: true
    };
  },
  methods: {
    ...mapActions({
      GROUP_ADD_MEMBER: "GROUP_ADD_MEMBER"
    }),
    async fetchUsers(params) {
      var { search } = params;
      var action = search ? searchInput(search) : "orderBy=lastName:ASC";
      this.isLoading = true;
      await this.$store.dispatch("USER_LIST_PAGINATE", action);
      this.isLoading = false;
    },
    handleType() {
      this.$store.dispatch("USER_LIST_RESET");
    },
    async handleAddMemberClick() {
      this.$store.dispatch("USER_LIST_RESET");
      await this.fetchUsers({ search: "" });
      if (this.selectedMember !== null) {
        this.addedMembers.push(this.selectedMember);
        this.selectedMember = null;
      }
    },
    async handleAddMemberToCompany() {
      if (this.addedMembers.length == 0) {
        if (this.selectedMember == null) {
          this.$toastr.warning(`Please choose a member`, "Warning");
          return;
        } else {
          this.addedMembers.push(this.selectedMember);
        }
      } else {
        if (this.selectedMember) {
          this.addedMembers.push(this.selectedMember);
        }
      }
      let singleRecord = this.singleRecord;
      let data = {
        groupId: singleRecord.id,
        users: []
      };
      let existing = [];
      for (let member of this.addedMembers) {
        let validateMember = await axios.get(
          `/groups/users?groupId=${singleRecord.id}&userId=${member.value}`
        );
        if (validateMember.data.data.length != 0) {
          existing.push(`${member.label} is already part of this company`);
        }
      }

      if (existing.length != 0) {
        this.$swal({
          type: "warning",
          html: `${existing.join("<br>")}`
        });
        return;
      }

      this.addedMembers.forEach(el => {
        data.users.push(el.value);
      });
      this.$toastr.success("Member is successfully added", "Success");
      this.GROUP_ADD_MEMBER(data);
      this.$emit("close");
    },
    handleMemberRemoveClick(params) {
      const { index } = params;
      this.addedMembers.find((e, i) => {
        if (index === i) {
          this.addedMembers.splice(i, 1);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.form-group {
  .input-wrapper {
    button {
      margin-left: 15px;
    }
  }
  label {
    font-weight: 500;
    font-size: $font-size-xs;
  }
  input {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
  }
  ul {
    font-size: $font-size-xs;
  }
}
</style>
